export default __webpack_public_path__ + "static/media/CompensaVienna.4d77aa6b.png";